<template>
  <layout-full>
    <b-col cols="12">
      <div class="text-center">
        <h1>
          <slot/>
        </h1>
        <b-button class="btn btn-secondary btn-round" @click="$router.push({name: 'home'})">GO TO HOME PAGE</b-button>
      </div>
    </b-col>
  </layout-full>
</template>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

button {
  margin-top: $spacing-sm;
}
</style>

<script>
import layoutFull from './layout-full'
export default {
  components: {
    layoutFull
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/exception-page.vue